<template>

    <div class="w-full">

        <h4 class="mb-3 mt-6">Multicast Proxy</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addProxyPrompt = true">Add proxy</vs-button>

        <vx-card id="mCastProxyDiv" class="vs-con-loading__container">

            <vs-table :data="proxies" class="mt-3" search>

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div>
                        <vs-button :disabled="selectedProxies.length === 0" style="float: left" icon-pack="feather" icon="icon-play" color="success" class="mt-6; mr-1" @click="enableSelected"/>
                        <vs-button :disabled="selectedProxies.length === 0" style="float: left" icon-pack="feather" icon="icon-pause" color="warning" class="mt-6; mr-1" @click="disableSelected"/>
                        <vs-button :disabled="selectedProxies.length === 0" style="float: left" icon-pack="feather" icon="icon-trash-2" color="danger" class="mt-6; mr-1" @click="removeSelected"/>
                    </div>

                    <div style="clear: both"></div>
                </div>

                <template slot="thead">
                    <vs-th key="ch1" v-if="!allSelected" style="width: 25px"><vs-checkbox style="float: left; width: 25px" icon="remove" v-model="someSelected"/></vs-th>
                    <vs-th key="ch2" v-else style="width: 25px"><vs-checkbox style="float: left; width: 25px" v-model="allSelected"/></vs-th>
                    <vs-th sort-key="in_interface">Input Interface</vs-th>
                    <vs-th sort-key="in_address">Input Address</vs-th>
                    <vs-th sort-key="in_port">Input Port</vs-th>
                    <vs-th sort-key="out_interface">Output Interface</vs-th>
                    <vs-th sort-key="out_address">Output Address</vs-th>
                    <vs-th sort-key="out_port">Output Port</vs-th>
                    <vs-th sort-key="ttl">TTL</vs-th>
                    <vs-th sort-key="comment">Comment</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :key="tr.id" style="width: 25px">
                            <vs-checkbox style="float: left; width: 25px" v-model="selectedProxies" :vs-value="data[index].id"/>
                        </vs-td>

                        <vs-td :data="data[index].in_interface">
                            {{ data[index].in_interface }}
                        </vs-td>

                        <vs-td :data="data[index].in_address">
                            {{ data[index].in_address }}
                        </vs-td>

                        <vs-td :data="data[index].in_port">
                            {{ data[index].in_port }}
                        </vs-td>

                        <vs-td :data="data[index].out_interface">
                            {{ data[index].out_interface }}
                        </vs-td>

                        <vs-td :data="data[index].out_address">
                            {{ data[index].out_address }}
                        </vs-td>

                        <vs-td :data="data[index].out_port">
                            {{ data[index].out_port }}
                        </vs-td>

                        <vs-td :data="data[index].ttl">
                            {{ data[index].ttl }}
                        </vs-td>

                        <vs-td :data="data[index].comment">
                            {{ data[index].comment }}
                        </vs-td>

                        <vs-td style="width: 165px">
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-edit" color="primary" class="md:mb-0 mr-1 mb-1" @click="openProxyEdit(data[index])"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-play" color="success" class="md:mb-0 mr-1 mb-1" v-if="data[index].disabled" @click="enableProxy(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-pause" color="warning" class="md:mb-0 mr-1 mb-1" v-if="!data[index].disabled" @click="disableProxy(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-trash-2" color="danger" class="md:mb-0 mr-1 mb-1" @click="removeProxy(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>

        </vx-card>

        <vs-popup title="Add Multicast Proxy" :active.sync="addProxyPrompt">
            <div id="addProxyDiv" class="vs-con-loading__container" >

                <h5>Input</h5>
                <div class="vx-row mt-1">
                    <div class="vx-col w-3/12">
                        <p>Type</p>
                        <vs-select autocomplete class="w-full" v-model="addObject['in_type']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Interface'}, {id:1, name:'Multicast Node'}]" />
                        </vs-select>
                    </div>
                    <div v-if="addObject['in_type'] === 0" class="vx-col w-3/12">
                        <p>Interface</p>
                        <vs-input v-model="addObject['in_interface']" class="w-full"></vs-input>
                    </div>
                    <div v-else class="vx-col w-3/12">
                        <p>Node</p>
                        <vs-select autocomplete class="w-full" v-model="addObject['in_multicast_node']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-4/12">
                        <p>Address</p>
                        <vs-input v-model="addObject['in_address']" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-2/12">
                        <p>Port</p>
                        <vs-input v-model="addObject['in_port']" class="w-full"></vs-input>
                    </div>
                </div>

                <h5 class="mt-6">Output</h5>
                <div class="vx-row mt-1">
                    <div class="vx-col w-3/12">
                        <p>Type</p>
                        <vs-select autocomplete class="w-full" v-model="addObject['out_type']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Interface'}, {id:1, name:'Multicast Node'}]" />
                        </vs-select>
                    </div>
                    <div v-if="addObject['out_type'] === 0" class="vx-col w-3/12">
                        <p>Interface</p>
                        <vs-input v-model="addObject['out_interface']" class="w-full"></vs-input>
                    </div>
                    <div v-else class="vx-col w-3/12">
                        <p>Node</p>
                        <vs-select autocomplete class="w-full" v-model="addObject['out_multicast_node']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-4/12">
                        <p>Address</p>
                        <vs-input v-model="addObject['out_address']" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-2/12">
                        <p>Port</p>
                        <vs-input v-model="addObject['out_port']" class="w-full"></vs-input>
                    </div>
                </div>
                <p class="mt-6">TTL</p>
                <vs-input v-model="addObject['ttl']" class="w-full"></vs-input>

                <p class="mt-6">Comment</p>
                <vs-input v-model="addObject['comment']" class="w-full"></vs-input>

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addProxy">Add</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Edit Multicast Proxy" :active.sync="editProxyPrompt">
            <div id="editProxyDiv" class="vs-con-loading__container" >

                <h5>Input</h5>
                <div class="vx-row mt-1">
                    <div class="vx-col w-3/12">
                        <p>Type</p>
                        <vs-select autocomplete class="w-full" v-model="editObject['in_type']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Interface'}, {id:1, name:'Multicast Node'}]" />
                        </vs-select>
                    </div>
                    <div v-if="editObject['in_type'] === 0" class="vx-col w-3/12">
                        <p>Interface</p>
                        <vs-input v-model="editObject['in_interface']" class="w-full"></vs-input>
                    </div>
                    <div v-else class="vx-col w-3/12">
                        <p>Node</p>
                        <vs-select autocomplete class="w-full" v-model="editObject['in_multicast_node']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-4/12">
                        <p>Address</p>
                        <vs-input v-model="editObject['in_address']" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-2/12">
                        <p>Port</p>
                        <vs-input v-model="editObject['in_port']" class="w-full"></vs-input>
                    </div>
                </div>

                <h5 class="mt-6">Output</h5>
                <div class="vx-row mt-1">
                    <div class="vx-col w-3/12">
                        <p>Type</p>
                        <vs-select autocomplete class="w-full" v-model="editObject['out_type']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Interface'}, {id:1, name:'Multicast Node'}]" />
                        </vs-select>
                    </div>
                    <div v-if="editObject['out_type'] === 0" class="vx-col w-3/12">
                        <p>Interface</p>
                        <vs-input v-model="editObject['out_interface']" class="w-full"></vs-input>
                    </div>
                    <div v-else class="vx-col w-3/12">
                        <p>Node</p>
                        <vs-select autocomplete class="w-full" v-model="editObject['out_multicast_node']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-4/12">
                        <p>Address</p>
                        <vs-input v-model="editObject['out_address']" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-2/12">
                        <p>Port</p>
                        <vs-input v-model="editObject['out_port']" class="w-full"></vs-input>
                    </div>
                </div>
                <p class="mt-6">TTL</p>
                <vs-input v-model="editObject['ttl']" class="w-full"></vs-input>

                <p class="mt-6">Comment</p>
                <vs-input v-model="editObject['comment']" class="w-full"></vs-input>

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="editProxy">Save</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {
        props: {
            workerId: {
                type: Number,
                required: true
            },
            channelId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                selectedProxies: [],
                proxies: [],

                addObject: {
                    in_type: 0,
                    out_type: 0
                },
                editObject: {},

                nodes: [],

                addProxyPrompt: false,
                editProxyPrompt: false
            }
        },
        methods: {
            openProxyEdit(data) {
                this.editObject = JSON.parse(JSON.stringify(data))
                this.editProxyPrompt = true
            },
            loadData() {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.workerId + '/multicast_proxy?channelId=' + this.channelId)
                loadPromise.then(function(response) {
                    thisIns.proxies = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const nodeLoadPromise = this.$http.get('/api/management/v1/worker/' + this.workerId + '/multicast_node')
                nodeLoadPromise.then(function(response) {
                    thisIns.nodes = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, nodeLoadPromise]).finally(function() {
                    thisIns.$vs.loading.close('#mCastProxyDiv > .con-vs-loading')
                })
            },
            addProxy() {
                this.$vs.loading({
                    container: '#addProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/worker/' + this.workerId + '/multicast_proxy', {
                    worker_channel_id: this.channelId,
                    in_type: Number(this.addObject.in_type),
                    in_multicast_node: Number(this.addObject.in_multicast_node),
                    in_interface: this.addObject.in_interface,
                    in_address: this.addObject.in_address,
                    in_port: Number(this.addObject.in_port),
                    out_type: Number(this.addObject.out_type),
                    out_multicast_node: Number(this.addObject.out_multicast_node),
                    out_interface: this.addObject.out_interface,
                    out_address: this.addObject.out_address,
                    out_port: Number(this.addObject.out_port),
                    ttl: Number(this.addObject.ttl),
                    comment: this.addObject.comment
                })

                addPromise.then(function() {
                    thisIns.$vs.loading.close('#addProxyDiv > .con-vs-loading')
                    thisIns.$nextTick(function() {
                        thisIns.addProxyPrompt = false
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addProxyDiv > .con-vs-loading')
                })
            },
            editProxy() {
                this.$vs.loading({
                    container: '#editProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const editPromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + this.editObject.id, {
                    in_type: Number(this.editObject.in_type),
                    in_multicast_node: Number(this.editObject.in_multicast_node),
                    in_interface: this.editObject.in_interface,
                    in_address: this.editObject.in_address,
                    in_port: Number(this.editObject.in_port),
                    out_type: Number(this.editObject.out_type),
                    out_multicast_node: Number(this.editObject.out_multicast_node),
                    out_interface: this.editObject.out_interface,
                    out_address: this.editObject.out_address,
                    out_port: Number(this.editObject.out_port),
                    ttl: Number(this.editObject.ttl),
                    comment: this.editObject.comment
                })

                editPromise.then(function() {
                    thisIns.$vs.loading.close('#editProxyDiv > .con-vs-loading')
                    thisIns.$nextTick(function() {
                        thisIns.editProxyPrompt = false
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#editProxyDiv > .con-vs-loading')
                })
            },
            enableProxy(id) {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const enablePromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + id + '/enable')
                enablePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.loadData()
                })
            },
            disableProxy(id) {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const disablePromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + id + '/disable')
                disablePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.loadData()
                })
            },
            removeProxy(id) {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + id)
                removePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    if (thisIns.selectedProxies.includes(id)) {
                        thisIns.selectedProxies.splice(thisIns.selectedProxies.indexOf(id), 1)
                    }
                    thisIns.loadData()
                })
            },
            enableSelected() {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedProxies.length; x++) {
                    const reqPromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + this.selectedProxies[x] + '/enable')
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                })
            },
            disableSelected() {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedProxies.length; x++) {
                    const reqPromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + this.selectedProxies[x] + '/disable')
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                })
            },
            removeSelected() {
                this.$vs.loading({
                    container: '#mCastProxyDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedProxies.length; x++) {
                    const reqPromise = this.$http.delete('/api/management/v1/worker/' + this.workerId + '/multicast_proxy/' + this.selectedProxies[x])
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)

                    this.selectedProxies.splice(x, 1)
                    x--
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                })
            }
        },
        computed: {
            allSelected: {
                get() {
                    if (this.proxies.length === 0) return false

                    for (let x = 0; x < this.proxies.length; x++) {
                        if (!this.selectedProxies.includes(this.proxies[x].id)) return false
                    }

                    return true
                },
                set() {
                    if (this.allSelected) {
                        this.selectedProxies = []
                        return
                    }

                    for (let x = 0; x < this.proxies.length; x++) {
                        if (!this.selectedProxies.includes(this.proxies[x].id)) {
                            this.selectedProxies.push(this.proxies[x].id)
                        }
                    }
                }
            },
            someSelected: {
                get() {
                    return this.proxies.length > this.selectedProxies.length && this.selectedProxies.length > 0
                },
                set() {
                    for (let x = 0; x < this.proxies.length; x++) {
                        if (!this.selectedProxies.includes(this.proxies[x].id)) {
                            this.selectedProxies.push(this.proxies[x].id)
                        }
                    }
                }
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
